/**
 * Track when an element is becomes visible in the document (not the viewport)
 *
 * @param {Element} element
 * @param {(visible: boolean) => void} callback
 * @param {{
 *   target?: Node|null
 *   rootMargin?: string
 * }} options
 * @returns
 */
export function trackVisibility(
  element,
  callback,
  { target = null, rootMargin = '0px 0px 0px 0px' } = {},
) {
  let observer = new IntersectionObserver(
    ([{ isIntersecting }]) => {
      callback(isIntersecting)
    },
    {
      root: target,
      rootMargin,
    },
  )

  observer.observe(element)

  return () => {
    observer.disconnect()
  }
}

/**
 * Wait until an element becomes visible/hidden in the document (not the viewport)
 *
 * @param {Element} element
 * @param {boolean} state
 * @param {{
 *   state?: boolean
 *   target?: Node|null
 *   rootMargin?: string
 * }} options
 * @returns {Promise<void>}
 */
export function waitVisiblility(element, options) {
  const { state = true, ...trackOptions } = options

  return new Promise(resolve => {
    let stop = trackVisibility(
      element,
      visible => {
        if (visible === state) {
          resolve()
          stop()
        }
      },
      trackOptions,
    )
  })
}
